import { Reveal, SectionHeader } from "@/components/Reveal";

export default function Problem() {
  return (
    <section
      id="problem"
      data-testid="problem-section"
      className="relative border-t border-[#E2E8F0] bg-white py-24 lg:py-32"
    >
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:gap-10 lg:px-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <SectionHeader
              index="01"
              label="The Problem"
              testid="problem-heading"
              title={
                <>
                  The AI &ldquo;set it and forget it&rdquo;{" "}
                  <span className="italic text-[#EB5E28]">illusion</span>.
                </>
              }
            />
          </div>
        </div>

        <div className="lg:col-span-7" data-testid="problem-content">
          <Reveal>
            <p className="text-base leading-relaxed text-[#4A5361] sm:text-lg">
              Companies are rapidly deploying AI workflows to scale operations without expanding
              their footprint. But artificial intelligence is only efficient at the predictable{" "}
              <span className="font-semibold text-[#0F141A]">80%</span>.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-base leading-relaxed text-[#4A5361] sm:text-lg">
              When an automated process encounters an exception it wasn't trained for, it drops an
              unstructured mess directly into your team's lap. Employees are forced to stop their
              strategic work to reverse-engineer the machine's mistake. Customers are left stranded.
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-9 border-l-2 border-[#EB5E28] pl-6 font-display text-2xl font-medium leading-snug text-[#0F141A] sm:text-3xl">
              The workflow isn't failing because the technology is flawed; it is failing because the
              handoff from the machine back to the human was{" "}
              <span className="italic text-[#EB5E28]">never engineered</span>.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
